import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { loadRuntimeConfig } from './runtimeConfig';
import './styles.css';
import './simple.css';

// 'm' / 'k' shortcut on number inputs: multiply current value by 1 000 000 / 1 000
const _nativeValueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value')?.set;
document.addEventListener('keydown', (e) => {
  if (!(e.target instanceof HTMLInputElement) || e.target.type !== 'number') return;
  const mult = (e.key === 'm' || e.key === 'M') ? 1_000_000 : (e.key === 'k' || e.key === 'K') ? 1_000 : 0;
  if (!mult) return;
  const current = parseFloat(e.target.value);
  if (isNaN(current)) return;
  e.preventDefault();
  _nativeValueSetter?.call(e.target, String(current * mult));
  e.target.dispatchEvent(new Event('input', { bubbles: true }));
}, true);

loadRuntimeConfig().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
}).catch((e: unknown) => {
  document.getElementById('root')!.innerHTML =
    `<div style="padding:40px;font-family:sans-serif;color:#cc2200">Failed to load application config: ${e instanceof Error ? e.message : String(e)}</div>`;
});
